
import React from 'react';
import { Row, Col, Image } from "antd";
import { Typography, TextField, Tab, Tooltip, IconButton } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import moment from 'moment';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import infoMarkIcon from "../../../../../../assets/images/icon_actions/infoMark.svg";


export const DeliveryView = (props) => {
    const { classes, clsx, form, error, changeHandler, handleChange, value,
        stateDetails, pincodeDetails, countryDetails, areaDetails, cityDetails,
        view, idNamingConversion, capitalizeFirstLetter, customObject } = props;


    return (
        <div className={classes.tabDesign}>
            <TabContext value={value}>
                <TabList onChange={(event, newValue) => handleChange(newValue)}>
                    <Tab className={classes.Bordertab_1} label="Line View" value={"lineView"} />
                    <Tab className={classes.Bordertab_2} label="Header View" value={"headerView"} />
                </TabList>
                <TabPanel value={"lineView"}>
                    <Row>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                        </Col>
                    </Row>
                    <Row gutter={50}>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Order Number</Typography>
                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={65} sm={12} xs={12}>
                            <Row>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24} className={classes.textAlignRight}>
                                    <span className={clsx(classes.statusButton,
                                        { [classes.submittedButton]: form.OrderStatus === 'SUBMITTED' || form.OrderStatus === 'RECEIVED' },
                                        { [classes.acceptedButton]: form.OrderStatus === 'ACCEPTED' },
                                        { [classes.openButton]: form.OrderStatus === 'REJECTED' },
                                        { [classes.reSubmittedButton]: form.OrderStatus === 'RESUBMITTED' },
                                        { [classes.cancelledButton]: form.OrderStatus === 'CANCELLED' },
                                        { [classes.confirmedButton]: form.OrderStatus === 'DELIVERED' || form.OrderStatus === 'INVOICED' || form.OrderStatus === 'ORDERED' },
                                        classes.margin20t)}>{form.OrderStatus || 'CREATED'}</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>In-AppTransactions</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.inAppTransition ? 'Yes' : 'No'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Price Includes Tax</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={24} sm={24} xs={24}>
                            <TextField autoComplete='one-time-code'
                                label={["Comments"]}
                                fullWidth
                                name={"comments"}
                                id={idNamingConversion('Comments', 'salesOrder', 'TextField')}
                                variant={'standard'}
                                value={form?.comments || ''}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer Name </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Phone Number </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.phone || '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, { [classes.margin20t]: !view }, { [classes.margin30t]: view }, 'MuiInputLabel-shrink', classes.fonSize13)}>Created By</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdBy || '----'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        tabIndex={-1}
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.deliveryDate || null}
                                        label="Delivery Date"
                                        PopperProps={{
                                            className: classes.dateAdjust,
                                        }}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                error: error?.deliveryDate ? true : false,
                                                helperText: error?.deliveryDate,
                                                id: idNamingConversion('Delivery Date', 'salesOrder', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError || newValue === null) {
                                                changeHandler(new Date(), 'deliveryDate');
                                            } else {
                                                changeHandler(newValue, 'deliveryDate');
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                            <TextField autoComplete='one-time-code'
                                label={["Reference"]}
                                fullWidth
                                name={"reference"}
                                id={idNamingConversion('Reference', 'salesOrder', 'TextField')}
                                className={clsx(classes.margin30t)}
                                variant={'standard'}
                                value={form?.reference || ''}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    }
                                }}
                                disabled={form?.inAppTransition || false}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                        </Col>
                    </Row>
                </TabPanel>
                <TabPanel value={"headerView"}>
                    <Row gutter={50}>
                        <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                            <Row gutter={50}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Order Number</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'} </Typography>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                            <span className={clsx(classes.statusButton,
                                                { [classes.submittedButton]: form.OrderStatus === 'SUBMITTED' || form.OrderStatus === 'RECEIVED' },
                                                { [classes.acceptedButton]: form.OrderStatus === 'ACCEPTED' },
                                                { [classes.openButton]: form.OrderStatus === 'REJECTED' },
                                                { [classes.reSubmittedButton]: form.OrderStatus === 'RESUBMITTED' },
                                                { [classes.cancelledButton]: form.OrderStatus === 'CANCELLED' },
                                                { [classes.confirmedButton]: form.OrderStatus === 'DELIVERED' || form.OrderStatus === 'INVOICED' || form.OrderStatus === 'ORDERED' },
                                                classes.margin20t)}>{form.OrderStatus || 'CREATED'}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>In-AppTransactions</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.inAppTransition ? 'Yes' : 'No'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Price Includes Tax</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.priceIncludesTax ? 'Yes' : 'No'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer Name </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer ID</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx({ [classes.margin20t]: !view }, { [classes.margin30t]: view }, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(form.OrderStatus || 'CREATED')}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Transaction Date</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {form.transactionDate ? moment(form.transactionDate).format('DD MMM YYYY') : '---'}
                                    </Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.deliveryDate || null}
                                                label="Delivery Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.deliveryDate ? true : false,
                                                        helperText: error?.deliveryDate,
                                                        id: idNamingConversion('Delivery Date', 'salesOrder', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                minDate={form?.transactionDate}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'deliveryDate');
                                                    } else {
                                                        changeHandler(newValue, 'deliveryDate');
                                                    }
                                                }}

                                            />
                                        </LocalizationProvider>
                                    </div>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Phone Number </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.phone || '---'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Method of Payment (MOP)</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mop?.method || '---'}</Typography>

                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Currency</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.currency?.name || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Email</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.email || '---'}</Typography>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        label=''
                                        placeholder='Reference'
                                        value={form?.reference}
                                        variant={'outlined'}
                                        className={clsx(classes.customDescription, classes.margin30t)}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        name={"reference"}
                                        disabled={form?.inAppTransition || false}
                                        id={idNamingConversion('Reference', 'salesOrder', 'TextField')}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                                </Col>
                                <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        label=''
                                        placeholder='Comments'
                                        value={form?.comments}
                                        variant={'outlined'}
                                        className={clsx(classes.customDescription, classes.margin30t)}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        name={"comments"}
                                        id={idNamingConversion('Comments', 'salesOrder', 'TextField')}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                            <Row gutter={50} className={clsx(classes.mobileViewSalesCreate)}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'h6'} style={{ height: 40 }} className={clsx(classes.typographyHeader, classes.typographyHeaderToolTip, classes.bold)}><span>Address</span>
                                        <Tooltip
                                            classes={{ popper: classes.customToolTip }}
                                            title={'The Address selected here will determine the Tax Applicable'} arrow placement="top" className={classes.tooltip}>
                                            <IconButton>
                                                <Image src={infoMarkIcon} preview={false} />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <TextField autoComplete='one-time-code'
                                        label={["Delivery Name ", <span key={"Delivery Name"} className={classes.colorRedRequired}> *</span>]}
                                        fullWidth
                                        name={"name"}
                                        id={idNamingConversion('Name', 'salesOrder', 'TextField')}
                                        variant={'standard'}
                                        value={form?.name || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        error={error?.name ? true : false}
                                        helperText={error?.name}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        className={clsx(classes.margin10t)}
                                        onChange={(e) => changeHandler(e)}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={["State/Province - Place of Supply ", <span key={"State/Province - Place of Supply"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'State Name' },
                                        { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                        details={stateDetails}
                                        id={idNamingConversion('State', 'salesOrder', 'DropDown')}
                                        parentValue={customObject(stateDetails, form?.stateId)}
                                        onChange={(data) => changeHandler(data, 'stateId', true)}
                                        position={"bottom"}
                                        customClasses={clsx(classes.margin30t)}
                                        parentError={error?.stateId || false}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={["Country"]}
                                        heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                        details={countryDetails}
                                        id={idNamingConversion('Country', 'salesOrder', 'DropDown')}
                                        parentValue={customObject(countryDetails, form?.countryId)}
                                        onChange={(data) => changeHandler(data, 'countryId', true)}
                                        position={"bottom"}
                                        customClasses={classes.margin30t}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'code', 'name': 'Pincode' }, { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                        details={pincodeDetails}
                                        id={idNamingConversion('Pincode', 'salesOrder', 'DropDown')}
                                        parentValue={customObject(pincodeDetails, form?.pincodeId)}
                                        onChange={(data) => changeHandler(data, 'pincodeId', true)}
                                        position={"bottom"}
                                        customClasses={classes.margin30t}
                                        parentError={error?.pincodeId || false}
                                    />
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <AutoCompleteComponent
                                        name={["Dist/City/Town"]}
                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                        { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                        details={cityDetails}
                                        id={idNamingConversion('City', 'salesOrder', 'DropDown')}
                                        parentValue={customObject(cityDetails, form?.cityId)}
                                        onChange={(data) => changeHandler(data, 'cityId', true)}
                                        position={"top"}
                                        customClasses={classes.margin30t}
                                    />
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <AutoCompleteComponent
                                        name={["Area"]}
                                        heads={[{ 'key': 'name', 'name': 'Area Name' },
                                        { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                        { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                        { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                        details={areaDetails}
                                        id={idNamingConversion('Area', 'salesOrder', 'DropDown')}
                                        parentValue={customObject(areaDetails, form?.areaId)}
                                        onChange={(data) => changeHandler(data, 'areaId', true)}
                                        position={"top"}
                                        customClasses={classes.margin30t}
                                        customLink={'/admin/address/area'}
                                        linkText={'Go to Area'}
                                        infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                    />
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.mobileAreaAddress)}>
                                    <div className={clsx(classes.margin30t, classes.positionRelative)}>
                                        <TextField autoComplete='one-time-code'
                                            label=''
                                            placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                            value={form?.address1}
                                            variant={'outlined'}
                                            className={clsx(classes.customDescription)}
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name={"address1"}
                                            id={idNamingConversion('Address', 'salesOrder', 'TextField')}
                                            InputProps={{
                                                classes: {
                                                    input: clsx(classes.textFieldColor),
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    </div>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </TabPanel>
            </TabContext>
        </div>
    )
}